import React, { useContext } from "react"
import * as AppConstants from "../../../utility/AppConstants"
import InfoRiservatezza from "../../avvisi/InfoRiservatezza"

import TabRicaviCompensi from "./include/TabRicaviCompensi"
import TabValoreAggiunto from "./include/TabValoreAggiunto"
import TabReddito from "./include/TabReddito"
import TabIndicatori from "./include/TabIndicatori"
import TabGestioneCaratteristica from "./include/TabGestioneCaratteristica"
import TabRedditivita from "./include/TabRedditivita"
import TabGestioneExtra from "./include/TabGestioneExtra"
import TabIndicatoriSpecifici from "./include/TabIndicatoriSpecifici"
import TabAnomalie from "./include/TabAnomalie"
import TabTitle from "./include/TabTitle"

import HeaderTable from "../../table/HeaderTable"
import BodyTable from "../../table/BodyTable"
import {
    Table,
    Collapsible,
    SimpleCard
} from "@sogei/react-web-components-catalog"
import HeaderTableTotali from "@/components/table/HeaderTableTotali"
import BodyTableCpb from "@/components/table/BodyTableCpb"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"
function TabSocietaPersone(props: any) {
    let totaleSocietaPersone = props.totaleSocietaPersone
    let societaPersoneRe = props.societaPersoneRe
    let societaPersoneRg = props.societaPersoneRg
    let societaPersoneRf = props.societaPersoneRf

    const [multiAnnoState] = useContext(MultiAnnoContext)
    return (
        <div id="tab-societa-persone">
            <TabTitle title={AppConstants.TITLE_SOCIETA_PERSONE} {...props} />

            <div className="row">
                <div className="col-12">
                    <SimpleCard
                        cardType="default"
                        title={""}
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            title={AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()}
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            datiNazionali={props.datiNazionali}
                                        />
                                    }
                                    tableBody={
                                        <BodyTable
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            isCampo5={false}
                                            campo1={societaPersoneRe}
                                            campo2={societaPersoneRg}
                                            campo3={societaPersoneRf}
                                            campo4={totaleSocietaPersone}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE}{" "}
                                    </caption>
                                </Table>
                            </div>
                        }
                    />
                </div>
            </div>

            {multiAnnoState.rangeAnni.get(Number(props.anno)) && (
                <>
                    <div className="row">
                        <div className="col-12">
                            <h1 className="h3"> {AppConstants.TITLE_CPB} </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <BodyTableCpb
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo4={true}
                                                isCampo5={false}
                                                campo1={societaPersoneRe}
                                                campo2={societaPersoneRg}
                                                campo3={societaPersoneRf}
                                                campo4={totaleSocietaPersone}
                                                anno={props.anno}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI}{" "}
                                    </caption>
                                </Table>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <div className="row">
                <div className="col-12">
                    <h1 className="h3"> {AppConstants.DATI_AFFIDABILITA} </h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_RICAVI_COMPENSI}
                        titleHeading="h3"
                        body={
                            <>
                                <div className="table-responsive">
                                    <Table
                                        tableHead={
                                            <HeaderTable
                                                title={AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()}
                                                codIsa={props.codIsa}
                                                macroarea={props.macroarea}
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo4={true}
                                                datiNazionali={
                                                    props.datiNazionali
                                                }
                                            />
                                        }
                                        tableBody={
                                            <TabRicaviCompensi
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo4={true}
                                                isCampo5={false}
                                                campo1={societaPersoneRe}
                                                campo2={societaPersoneRg}
                                                campo3={societaPersoneRf}
                                                campo4={totaleSocietaPersone}
                                            />
                                        }
                                        tableOptions={["table-striped"]}
                                    >
                                        <caption className="sr-only">
                                            {AppConstants.TITLE_SOCIETA_PERSONE}{" "}
                                            -{" "}
                                            {AppConstants.DATI_RICAVI_COMPENSI}
                                        </caption>
                                    </Table>
                                </div>
                                <div className="info_ricavi_compensi">
                                    {AppConstants.INFO_RICAVI_COMPENSI}
                                </div>
                            </>
                        }
                        id="DATI_RICAVI_COMPENSI"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_VALORE_AGGIUNTO}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            title={AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()}
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            datiNazionali={props.datiNazionali}
                                        />
                                    }
                                    tableBody={
                                        <TabValoreAggiunto
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            isCampo5={false}
                                            campo1={societaPersoneRe}
                                            campo2={societaPersoneRg}
                                            campo3={societaPersoneRf}
                                            campo4={totaleSocietaPersone}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_VALORE_AGGIUNTO}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_VALORE_AGGIUNTO"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_REDDITO}
                        titleHeading="h3"
                        body={
                            <>
                                <div className="table-responsive">
                                    <Table
                                        tableHead={
                                            <HeaderTable
                                                title={AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()}
                                                codIsa={props.codIsa}
                                                macroarea={props.macroarea}
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo4={true}
                                                datiNazionali={
                                                    props.datiNazionali
                                                }
                                            />
                                        }
                                        tableBody={
                                            <TabReddito
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                isCampo4={true}
                                                isCampo5={false}
                                                campo1={societaPersoneRe}
                                                campo2={societaPersoneRg}
                                                campo3={societaPersoneRf}
                                                campo4={totaleSocietaPersone}
                                            />
                                        }
                                        tableOptions={["table-striped"]}
                                    >
                                        <caption className="sr-only">
                                            {AppConstants.TITLE_SOCIETA_PERSONE}{" "}
                                            - {AppConstants.DATI_REDDITO}
                                        </caption>
                                    </Table>
                                </div>
                                <div className="info_ricavi_compensi">
                                    {AppConstants.INFO_REDDITO}
                                </div>
                            </>
                        }
                        id="DATI_REDDITO"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_INDICATORI_ELEM_AFF}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            title={AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()}
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            datiNazionali={props.datiNazionali}
                                        />
                                    }
                                    tableBody={
                                        <TabIndicatori
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            isCampo5={false}
                                            campo1={societaPersoneRe}
                                            campo2={societaPersoneRg}
                                            campo3={societaPersoneRf}
                                            campo4={totaleSocietaPersone}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_INDICATORI_ELEM_AFF}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_INDICATORI_ELEM_AFF"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">&nbsp;</div>
            </div>

            <div className="row">
                <div className="col-12">&nbsp;</div>
            </div>

            <div className="row">
                <div className="col-12">
                    <h1 className="h3"> {AppConstants.DATI_ANOMALIA} </h1>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_GESTIONE_CAR}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            title={AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()}
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            datiNazionali={props.datiNazionali}
                                        />
                                    }
                                    tableBody={
                                        <TabGestioneCaratteristica
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            isCampo5={false}
                                            campo1={societaPersoneRe}
                                            campo2={societaPersoneRg}
                                            campo3={societaPersoneRf}
                                            campo4={totaleSocietaPersone}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_GESTIONE_CAR
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_ANOMALIA_GESTIONE_CAR"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_REDDITIVITA}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            title={AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()}
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            datiNazionali={props.datiNazionali}
                                        />
                                    }
                                    tableBody={
                                        <TabRedditivita
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            isCampo5={false}
                                            campo1={societaPersoneRe}
                                            campo2={societaPersoneRg}
                                            campo3={societaPersoneRf}
                                            campo4={totaleSocietaPersone}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_ANOMALIA}-{" "}
                                        {AppConstants.DATI_ANOMALIA_REDDITIVITA}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_ANOMALIA_REDDITIVITA"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_GESTIONE_EXTRA}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            title={AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()}
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            datiNazionali={props.datiNazionali}
                                        />
                                    }
                                    tableBody={
                                        <TabGestioneExtra
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            isCampo5={false}
                                            campo1={societaPersoneRe}
                                            campo2={societaPersoneRg}
                                            campo3={societaPersoneRf}
                                            campo4={totaleSocietaPersone}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_ANOMALIA}-{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_GESTIONE_EXTRA
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_ANOMALIA_GESTIONE_EXTRA"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_INDICATORI_SPECIFICI}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            title={AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()}
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            datiNazionali={props.datiNazionali}
                                        />
                                    }
                                    tableBody={
                                        <TabIndicatoriSpecifici
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            isCampo5={false}
                                            campo1={societaPersoneRe}
                                            campo2={societaPersoneRg}
                                            campo3={societaPersoneRf}
                                            campo4={totaleSocietaPersone}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_INDICATORI_SPECIFICI
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_ANOMALIA_INDICATORI_SPECIFICI"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_ALTRI_INDICATORI}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            title={AppConstants.TITLE_SOCIETA_PERSONE.toUpperCase()}
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            datiNazionali={props.datiNazionali}
                                        />
                                    }
                                    tableBody={
                                        <TabAnomalie
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            isCampo4={true}
                                            isCampo5={false}
                                            campo1={societaPersoneRe}
                                            campo2={societaPersoneRg}
                                            campo3={societaPersoneRf}
                                            campo4={totaleSocietaPersone}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_ALTRI_INDICATORI
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_ANOMALIA_ALTRI_INDICATORI"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <InfoRiservatezza />
                </div>
            </div>
        </div>
    )
}

export default TabSocietaPersone
